import * as _ from 'lodash';

const pickBrand = data =>
  _.omit(data, ['backgroundPhotoUrl', 'logoUrl']);

export default pickBrand;
